import { render, staticRenderFns } from "./MousePositionPlugin.vue?vue&type=template&id=b7de4d5e&scoped=true"
import script from "./MousePositionPlugin.vue?vue&type=script&lang=ts"
export * from "./MousePositionPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./MousePositionPlugin.vue?vue&type=style&index=0&id=b7de4d5e&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b7de4d5e",
  null
  ,true
)

export default component.exports